module.exports = __webpack_public_path__ + "5ea6d96ce5b826a99bf4e8460938dc6a.svg";